import React from 'react'
import { Modal } from 'hljd'
import { observer } from 'mobx-react'
import agreementContent from './content'
import Style from '../index.module.less'

export default observer(
  ({
    form,
    store: {
      handleAgreement,
      agreementVisible,
      showAgreementDetail,
      isShowAgreement
    }
  }) => {
    return (
      <Modal
        title="请阅读《婚礼纪视频直播服务协议》"
        centered
        width={618}
        visible={agreementVisible}
        wrapClassName={Style['living-agreement-modal']}
        okText={isShowAgreement ? <div /> : '本人已阅读并同意签署本协议'}
        onOk={() => !isShowAgreement && handleAgreement(true, form)}
        okButtonProps={{
          style: { display: isShowAgreement ? 'none' : 'inline-block' }
        }}
        cancelText={isShowAgreement ? '关闭' : '取消'}
        onCancel={() =>
          isShowAgreement ? showAgreementDetail() : handleAgreement(false, form)
        }
        cancelButtonProps={{
          type: '',
          style: { borderColor: '#d9d9d9', color: 'rgba(0,0,0,0.65)' }
        }}
      >
        <div className={Style['agreement-content']}>
          {/* 商家行为要求 */}
          <div>
            <h3>{agreementContent.seller_behavior.name}</h3>
            {agreementContent.seller_behavior.content.map((item, index) => {
              return (
                <p key={index}>
                  <br />
                  {index + 1}、{item}；
                </p>
              )
            })}
          </div>
          {/* 主播行为要求 */}
          <div>
            <br />
            <h3>{agreementContent.anchor_behavior.name}</h3>
            {agreementContent.anchor_behavior.content.map((item, index) => {
              if (item.key === 'cloth') {
                return (
                  <>
                    <p>
                      <br />1、{item.name}
                    </p>
                    <p>
                      <br />主播在直播时需着装整齐，忌穿过于低俗暴露服装。整体着装应干净、整洁、落落大方，具体要求：
                    </p>
                    <p>
                      <br />（1）女性严禁穿着大尺度裸露背部、裸露内衣、穿着露沟或容易露沟服装、短裙或短裤下摆高于臀下线的服装；
                    </p>
                    <p>
                      <br />（2）男性严禁赤裸上身或仅穿内裤；
                    </p>
                    <p>
                      <br />（3）严禁穿着特殊类装类型；
                    </p>
                    <p>
                      <br />1）严禁穿情趣制服、情趣内衣、暴露装、透视装、肉色紧身衣、内衣外穿、半截抹胸、渔网袜、吊带袜、三角短裤或呈现三角状短裤、低腰超短裤、有性暗示文字或图片的服装等；
                    </p>
                    <p>
                      <br />2）严禁穿着带有中华人民共和国（包含港澳台）国家机关人员、军队的工作制服进行直播。包括警服、军服、工商制服、检察院制服、法院制服、城管制服、路政制服等；
                    </p>
                  </>
                )
              } else {
                return (
                  <p key={index}>
                    <br />
                    {index + 1}、{item.name}
                    {item.content.map((item, index) => {
                      return (
                        <p key={index}>
                          <br />（{index + 1}）{item}；
                        </p>
                      )
                    })}
                  </p>
                )
              }
            })}
          </div>
          {/* 常见违规操作 */}
          <div>
            <br />
            <h3>{agreementContent.some_violation.name}</h3>
            {agreementContent.some_violation.content.map((item, index) => {
              return (
                <p key={index}>
                  <br />
                  {index + 1}、{item.name}；
                  {item.content.map((item, index) => {
                    return (
                      <p key={index}>
                        <br />
                        {item}；
                      </p>
                    )
                  })}
                </p>
              )
            })}
          </div>
          {/* 处理方式 */}
          <div>
            <br />
            <h3 style={{ color: '#CF1322' }}>
              *【{agreementContent.solution.name}】
            </h3>
            {agreementContent.solution.content.map((item, index) => {
              return (
                <p key={index}>
                  <br />
                  {index + 1}、{item}；
                </p>
              )
            })}
          </div>
        </div>
      </Modal>
    )
  }
)
